import { createFileRoute } from '@tanstack/react-router'
import { boardsQuery } from '~/features/tactics/queries'
import { BoardsPage } from '~/features/tactics/BoardsPage'
import { loaderScope } from '~/lib/session'

export const Route = createFileRoute('/_app/taktik/')({
  loader: async ({ context }) => {
    const scope = await loaderScope(context.queryClient)
    if (!scope.permissions.includes('training.read')) return
    // Errors show in the page (ErrorState with retry), not on the router's error screen.
    await context.queryClient.ensureQueryData(boardsQuery(scope.teamId)).catch(() => undefined)
  },
  component: BoardsPage,
})
